// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pop-tips[data-v-4a7c3645] {\n  text-align: center;\n  line-height: 1.5;\n}\n.pop-tips .title[data-v-4a7c3645] {\n  font-size: 14px;\n  color: #2F3030;\n}", ""]);
// Exports
module.exports = exports;
